{
  "generatedAt": "2026-11-03T13:39:35.622Z",
  "engineers": [
    {
      "key": "baltanos",
      "id": 400010,
      "name": "Baltanos",
      "systemAddress": 71536135676490,
      "marketId": 128986843
    },
    {
      "key": "bill-turner",
      "id": 300010,
      "name": "Bill Turner",
      "systemAddress": 1109989017963,
      "marketId": 128674183
    },
    {
      "key": "broo-tarquin",
      "id": 300030,
      "name": "Broo Tarquin",
      "systemAddress": 4481966019282,
      "marketId": 128674695
    },
    {
      "key": "chloe-sedesi",
      "id": 300300,
      "name": "Chloe Sedesi",
      "systemAddress": 594676730147,
      "marketId": 128954244
    },
    {
      "key": "colonel-bris-dekker",
      "id": 300140,
      "name": "Colonel Bris Dekker",
      "systemAddress": 10477373803,
      "marketId": 128677511
    },
    {
      "key": "didi-vatermann",
      "id": 300000,
      "name": "Didi Vatermann",
      "systemAddress": 3932277478114,
      "marketId": 128673927
    },
    {
      "key": "domino-green",
      "id": 400002,
      "name": "Domino Green",
      "systemAddress": 5068464399785,
      "marketId": 128973159
    },
    {
      "key": "eleanor-bresa",
      "id": 400011,
      "name": "Eleanor Bresa",
      "systemAddress": 38001031029322,
      "marketId": 128987099
    },
    {
      "key": "elvira-martuuk",
      "id": 300160,
      "name": "Elvira Martuuk",
      "systemAddress": 3107241104074,
      "marketId": 128678023
    },
    {
      "key": "etienne-dorn",
      "id": 300290,
      "name": "Etienne Dorn",
      "systemAddress": 11887629902418,
      "marketId": 128681351
    },
    {
      "key": "felicity-farseer",
      "id": 300100,
      "name": "Felicity Farseer",
      "systemAddress": 6681123623626,
      "marketId": 128676487
    },
    {
      "key": "hera-tani",
      "id": 300090,
      "name": "Hera Tani",
      "systemAddress": 1733321102034,
      "marketId": 128676231
    },
    {
      "key": "hero-ferrari",
      "id": 400003,
      "name": "Hero Ferrari",
      "systemAddress": 7269634614689,
      "marketId": 128973415
    },
    {
      "key": "jude-navarro",
      "id": 400001,
      "name": "Jude Navarro",
      "systemAddress": 7268024067513,
      "marketId": 128972903
    },
    {
      "key": "juri-ishmaak",
      "id": 300250,
      "name": "Juri Ishmaak",
      "systemAddress": 4481899074282,
      "marketId": 128680327
    },
    {
      "key": "kit-fowler",
      "id": 400004,
      "name": "Kit Fowler",
      "systemAddress": 2827975936355,
      "marketId": 128973671
    },
    {
      "key": "lei-cheung",
      "id": 300120,
      "name": "Lei Cheung",
      "systemAddress": 4305444669811,
      "marketId": 128676999
    },
    {
      "key": "liz-ryder",
      "id": 300080,
      "name": "Liz Ryder",
      "systemAddress": 1458309141194,
      "marketId": 128675975
    },
    {
      "key": "lori-jameson",
      "id": 300230,
      "name": "Lori Jameson",
      "systemAddress": 3932277478106,
      "marketId": 128679815
    },
    {
      "key": "marco-qwent",
      "id": 300200,
      "name": "Marco Qwent",
      "systemAddress": 121569805492,
      "marketId": 128679047
    },
    {
      "key": "marsha-hicks",
      "id": 300150,
      "name": "Marsha Hicks",
      "systemAddress": 48996147307082,
      "marketId": 128677767
    },
    {
      "key": "mel-brandon",
      "id": 300280,
      "name": "Mel Brandon",
      "systemAddress": 66038577537618,
      "marketId": 128681095
    },
    {
      "key": "oden-geiger",
      "id": 400008,
      "name": "Oden Geiger",
      "systemAddress": 8879744226018,
      "marketId": 128974695
    },
    {
      "key": "petra-olmanova",
      "id": 300130,
      "name": "Petra Olmanova",
      "systemAddress": 12274907287851,
      "marketId": 128677255
    },
    {
      "key": "professor-palin",
      "id": 300220,
      "name": "Professor Palin",
      "systemAddress": 113573366131,
      "marketId": 128679559
    },
    {
      "key": "ram-tah",
      "id": 300110,
      "name": "Ram Tah",
      "systemAddress": 3790082132323,
      "marketId": 128676743
    },
    {
      "key": "rosa-dayette",
      "id": 400012,
      "name": "Rosa Dayette",
      "systemAddress": 59166629864010,
      "marketId": 128986587
    },
    {
      "key": "selene-jean",
      "id": 300210,
      "name": "Selene Jean",
      "systemAddress": 24859942069665,
      "marketId": 128679303
    },
    {
      "key": "terra-velasquez",
      "id": 400006,
      "name": "Terra Velasquez",
      "systemAddress": 3721329101171,
      "marketId": 128974183
    },
    {
      "key": "the-dweller",
      "id": 300180,
      "name": "The Dweller",
      "systemAddress": 5031654888146,
      "marketId": 128678535
    },
    {
      "key": "the-sarge",
      "id": 300040,
      "name": "The Sarge",
      "systemAddress": 2827992680811,
      "marketId": 128674951
    },
    {
      "key": "tiana-fortune",
      "id": 300270,
      "name": "Tiana Fortune",
      "systemAddress": 164098653,
      "marketId": 128680839
    },
    {
      "key": "tod-the-blaster-mcquinn",
      "id": 300260,
      "name": "Tod 'The Blaster' McQuinn",
      "systemAddress": 3107576681170,
      "marketId": 128680583
    },
    {
      "key": "uma-laszlo",
      "id": 400007,
      "name": "Uma Laszlo",
      "systemAddress": 16065190962585,
      "marketId": 128974439
    },
    {
      "key": "wellington-beck",
      "id": 400005,
      "name": "Wellington Beck",
      "systemAddress": 2832832893634,
      "marketId": 128973927
    },
    {
      "key": "yarden-bond",
      "id": 400009,
      "name": "Yarden Bond",
      "systemAddress": 670686455169,
      "marketId": 128974951
    },
    {
      "key": "yi-shen",
      "id": 400013,
      "name": "Yi Shen",
      "systemAddress": 13736779007129,
      "marketId": 128987355
    },
    {
      "key": "zacariah-nemo",
      "id": 300050,
      "name": "Zacariah Nemo",
      "systemAddress": 6131367744226,
      "marketId": 128675207
    }
  ]
}
